export * from './language';
export * from './error';
export * from './paths';
export * from './request-data';
import * as Chart from 'chart.js';
import { formatNumber } from '@angular/common';

var theHelp = Chart.helpers;

export const
  HTTP_HEADER_CONSOLIDATOR_CODE = "Deconsolidator-Code",
  HTTP_HEADER_CONTENT_TYPE = 'Content-Type',
  HTTP_HEADER_AUTHORIZATION = 'Authorization',
  HTTP_HEADER_WEB_USER_ID = 'Web-User-Id',
  HTTP_HEADER_USER_CODE = 'User-Code',
  HTTP_HEADER_TOKEN = 'Token',
  HTTP_HEADER_MODULE_CODE = 'Module-Code',
  HTTP_HEADER_WAREHOUSE_CODE = 'Warehouse-Code',
  HTTP_HEADER_IS_CFS_WEB_REQUEST = 'Is-CFS-Web-Request',
  HTTP_HEADER_ACCESS_TOKEN = 'Access-Token',
  HTTP_HEADER_PUSH_TOKEN = 'Push-Token',
  HTTP_HEADER_WEBTOOL_VERSION = 'Webtool-Version',
  MIME_TYPE_JSON = 'application/json',
  URL_FORM_ENCODED = 'application/x-www-form-urlencoded',
  MULTIPART_FORM_DATA = 'multipart/form-data',

  ONHOLD_STATUS = "On-hold",
  SHORTLANDED_STATUS = "Shortlanded",
  OVERLANDED_STATUS = "Overlanded",

  SHOW_DATA = "SHOW_DATA",
  SHOW_S3 = "SHOW_S3",
  SEND_EMAIL = "SEND_EMAIL",

  STRIPPING_BY_YARD = "YARD",
  STRIPPING_BY_SF = "SF",
  STRIPPING_BY_STRIPPED = "STRIPPED",
  STRIPPING_BY_RELEASED = "RELEASED",

  DATE_FORMAT_YM_REQUEST = "YYYY-MM",
  DATE_FORMAT_YMD_REQUEST = "YYYY-MM-DD",

  FILTER_DEFAULT_START_TIME = "00:00:00",
  FILTER_DEFAULT_END_TIME = "23:59:00",

  DATE_FORMAT_VIEW = "MM/DD/YYYY",
  DATETIME_FORMAT_VIEW = "MM/DD/YYYY hh:mm A",

  URL_REGEX = /^(ftp|http|https):\/\/([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})(:[0-9]{1,5})?(\/[^#\?]*)(\?[^#\?]+)?(#.*)?$/,
  INTERNATIONAL_TELEPHONE_NO_REGEX = /^\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){0,13}\d$/,
  EMAIL_REGEX = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  DATETIME_FORMAT_FILE_PREFIX_S3 = "YYYYMMDDHHmmssSSS",
  DATETIME_FORMAT_REQUEST = "YYYY-MM-DD HH:mm:ss",
  TELEPHONE_NUMBER_REGEX = /^[0-9()+-]*$/,
  DEFAULT_CODE_REGEX = /^[a-zA-Z0-9_.]*$/,
  BBB_BOOKING_NUMBER_PATTERN = /^TRN-[0-9A-Fa-f]+-[0-9A-Fa-f]+$/,

  AIR_BOOKING_COMPLETE = "AIR_BOOKING_COMPLETE",

  MULTILINE_CHART_OPTION = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'bottom'
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 40,
        bottom: 10
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].toolTipLabel || '';
          // let label = 'Consignee Count';
          if (label) {
            label += ': ';
          }
          label += formatNumber(tooltipItem.yLabel, window.navigator.language, '1.0-2');
          return label;
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        formatter: (num) => {
          let fixed = 2;
          if (num === null) { return null; } // terminate early
          if (num === 0) { return '0'; } // terminate early
          fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
          let b = (num).toPrecision(2).split("e"), // get power
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
            d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
            e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
          return e;
        }
      }
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            beginAtZero: true,
            userCallback: function (label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            }
          },
          // scaleLabel: {
          //     display: true,
          //     labelString: '1k = 1000'
          // }
        }
      ],
      xAxes: [
        {
          gridLines: {
            display: false
          },
          offset: true,
          ticks: {
            // callback: function (value) {
            //   return _.truncate(value, { length: 10 });
            // }
          }
        }
      ]
    }
  },

  PIE_CHART_OPTIONS = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'left',
      labels: {
        boxWidth: 5,
        padding: 5,
        generateLabels: function (chart) {
          var data = chart.data;
          if (data.labels.length && data.datasets.length) {
            data.labels = data.labels.sort();
            return data.labels.map(function (label, i) {
              var title = label.substring(0, label.indexOf("-"));
              var meta = chart.getDatasetMeta(0);
              var ds = data.datasets[0];
              var sum = 0;
              var dataArr = data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
              var arc = meta.data[i];
              var custom = arc && arc.custom || {};
              var getValueAtIndexOrDefault = theHelp.getValueAtIndexOrDefault;
              var arcOpts = chart.options.elements.arc;
              var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
              var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
              var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
              return {
                // And finally : ds.data[i] + "% of the time " +  
                text: title + ' - ' + ((ds.data[i]) * 100 / sum).toFixed(2) + "%",
                fillStyle: fill,
                strokeStyle: stroke,
                lineWidth: bw,
                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                index: i
              };
            });
          }
          return [];
        }
      }
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          let title = data.labels[tooltipItem[0].index].split("-");
          return title[0];
        },
        label: function (tooltipItem, data) {
          let sum = 0;
          let dataArr = data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          let label;
          label = data.datasets[0].toolTipLabel + ": " + data.datasets[0].data[tooltipItem.index] + ' (' + (data.datasets[0].data[tooltipItem.index] * 100 / sum).toFixed(2) + "%)";
          return label;
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          let percentage = (value * 100 / sum).toFixed(2) + "%";
          return value;
        },
        display: false,
        color: "white"
      }
    },
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 10
      }
    }
  },
  BAR_CHART_OPTION = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 40,
        bottom: 10
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].toolTipLabel || '';

          if (label) {
            label += ': ';
          }
          label += formatNumber(tooltipItem.yLabel, window.navigator.language, '1.0-2');
          return label;
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        formatter: (num) => {
          let fixed = 2;
          if (num === null) { return null; } // terminate early
          if (num === 0) { return '0'; } // terminate early
          fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show

          let b = (num).toPrecision(4).split("e"); // get power

          let k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions

          let c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power

          let d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
          d = (d % 1 != 0) ? parseFloat(d).toFixed(3) : d;

          let e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
          return e;
        }
      }
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            beginAtZero: true,
            callback: function (num) {
              let fixed = 2;
              if (num === null) { return null; } // terminate early
              if (num === 0) { return '0'; } // terminate early
              fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
              let b = (num).toPrecision(2).split("e"); // get power
              let k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
              let c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power
              let d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
              if (Math.floor(d) === d) {
                let e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
                return e;
              }
            }
          }
          // ticks: {
          //   beginAtZero: true,
          //   userCallback: function (label, index, labels) {
          //     // when the floored value is the same as the value we have a whole number
          //     if (Math.floor(label) === label) {
          //       return label;
          //     }

          //   }
          // },
          // scaleLabel: {
          //     display: true,
          //     labelString: '1k = 1000'
          // }
        }
      ],
      xAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            // callback: function (value) {
            //   return _.truncate(value, { length: 10 });
            // }
          }
        }
      ]
    }
  };

  export enum StrippingTallySheetPrintType { 
    Stripping = "S",
    Consolidator = "C",
    Releasing = "R"
  }